/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Edit_Marker_TitleInputs */

const en_markers_edit_marker_title = /** @type {(inputs: Markers_Edit_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Marker`)
};

const fr_markers_edit_marker_title = /** @type {(inputs: Markers_Edit_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier le marqueur`)
};

const de_markers_edit_marker_title = /** @type {(inputs: Markers_Edit_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeitungsmarkierung`)
};

const it_markers_edit_marker_title = /** @type {(inputs: Markers_Edit_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica marcatore`)
};

const ru_markers_edit_marker_title = /** @type {(inputs: Markers_Edit_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать маркер`)
};

const es_markers_edit_marker_title = /** @type {(inputs: Markers_Edit_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar marcador`)
};

const zh_cn2_markers_edit_marker_title = /** @type {(inputs: Markers_Edit_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑标记`)
};

const ja_markers_edit_marker_title = /** @type {(inputs: Markers_Edit_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーを編集`)
};

const hi_markers_edit_marker_title = /** @type {(inputs: Markers_Edit_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर संपादित करें`)
};

const pt_pt2_markers_edit_marker_title = /** @type {(inputs: Markers_Edit_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcador de edição`)
};

/**
* | output |
* | --- |
* | "Edit Marker" |
*
* @param {Markers_Edit_Marker_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_edit_marker_title = /** @type {((inputs?: Markers_Edit_Marker_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Edit_Marker_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_edit_marker_title(inputs)
	if (locale === "de") return de_markers_edit_marker_title(inputs)
	if (locale === "it") return it_markers_edit_marker_title(inputs)
	if (locale === "ru") return ru_markers_edit_marker_title(inputs)
	if (locale === "es") return es_markers_edit_marker_title(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_edit_marker_title(inputs)
	if (locale === "ja") return ja_markers_edit_marker_title(inputs)
	if (locale === "hi") return hi_markers_edit_marker_title(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_edit_marker_title(inputs)
	return en_markers_edit_marker_title(inputs)
});